export const isAtlassianEmployee = (email?: string): boolean => {
	if (!email) {
		return false;
	}

	return email.toLowerCase().endsWith('@atlassian.com');
};
